import { useEffect, useState, useContext } from "react";
import { getProducts, deleteProduct } from "../../services/productApi";
import { getProductImages } from "../../services/imageApi";
import { Link } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";
import { AuthContext } from "../../context/AuthContext";

const Products = () => {
  const { user } = useContext(AuthContext);
  const [products, setProducts] = useState([]);
  const [imagesMap, setImagesMap] = useState({});
  const [loading, setLoading] = useState(false);

  // fetch products
  const fetchProducts = async () => {
    try {
      setLoading(true);

      const data = await getProducts();
      setProducts(data);

      // load images for each product
      loadImages(data);

    } catch (err) {
      alert("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  // load images per product
  const loadImages = async (products) => {
    try {
      const map = {};

      for (let p of products) {
        const imgs = await getProductImages(p.id);
        map[p.id] = imgs;
      }

      setImagesMap(map);
    } catch (err) {
      console.log("Image load error", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this product?")) return;

    try {
      await deleteProduct(id);
      fetchProducts();
    } catch (err) {
      alert("Delete failed");
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar role={user.role} />

      <div style={{ flex: 1 }}>
        <Navbar />

        <div style={{ padding: "20px" }}>
          <h2>Products</h2>

          {loading ? (
            <p>Loading...</p>
          ) : (
            <table border="1" cellPadding="10" width="100%">
              <thead>
                <tr>
                  <th>Images</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Stock</th>
                  <th>Category</th>
                  <th>Discount</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {products.map((p) => (
                  <tr key={p.id}>
                    
                    {/* IMAGE GALLERY */}
                    <td>
                      <div style={{ display: "flex", gap: "5px" }}>
                        {(imagesMap[p.id] || []).slice(0, 3).map((img) => (
                          <img
                            key={img.id}
                            src={`${img.image_url}`}
                            width="40"
                            height="40"
                            style={{
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: "1px solid #ccc",
                            }}
                          />
                        ))}

                        {(imagesMap[p.id] || []).length === 0 && (
                          <span style={{ fontSize: "12px", color: "gray" }}>
                            No images
                          </span>
                        )}
                      </div>
                    </td>

                    <td>{p.name}</td>
                    <td>₹{p.price}</td>
                    <td>{p.stock_quantity}</td>
                    <td>{p.category_name}</td>
                    <td>{p.discount_percent}%</td>

                    <td style={{ display: "flex", gap: "10px" }}>
                      
                      {/* MANAGE IMAGES */}
                      <Link to={`/admin/products/${p.id}/images`}>
                        <button>Images</button>
                      </Link>

                      <button onClick={() => handleDelete(p.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {!loading && products.length === 0 && (
            <p>No products found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Products;